export interface IDashboardAverageTrendsData {
  difference: number
  formattedDifference: string
}

export interface IDashboardTrendsItem {
  id: string
  displayText: string
  data: IDashboardAverageTrendsData
}

export interface IDashboardTrendsInfo {
  states: IDashboardTrendsItem[]
  regions: IDashboardTrendsItem[]
}

export interface IDashboardSalesTrendsResponse {
  markets: IDashboardTrendsInfo
}

export interface IDashboardCarsAvgTicketTiresTrendsResponse {
  cars: IDashboardTrendsInfo
  averageTicket: IDashboardTrendsInfo
  tireSales: IDashboardTrendsInfo
}

export interface IDashboardMergedTrends {
  id: string
  displayText: string
  sales?: IDashboardAverageTrendsData
  cars?: IDashboardAverageTrendsData
  averageTicket?: IDashboardAverageTrendsData
  tireSales?: IDashboardAverageTrendsData
}
